import type { AlertSeverity } from '@/types';
import { SEVERITY_STYLES } from '@/lib/severity';
import { cn } from '@/lib/cn';

export default function SeverityBadge({ severity, className }: {
  severity: AlertSeverity;
  className?: string;
}) {
  const s = SEVERITY_STYLES[severity];
  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-mono font-semibold tracking-wider rounded ring-1',
      s.bg, s.fg, s.ring, className,
    )}>
      <span className={cn('dot', s.dot)} />
      {s.label}
    </span>
  );
}
